import {useEffect, useId, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import {notifyError} from "../utils/helpers";
import classes from "./Dropdown.module.css";
import {YuJaTooltip} from "./standardization/YuJaTooltip";
import {ReactComponent as CHECK_ICON} from "../images/check_marker_purple.svg"
import {ReactComponent as TIME_LIMIT_ICON} from "../images/time_limit_gray.svg"
import YuJaSelect from "./standardization/YuJaSelect";


export default function DropdownTimeLimit({
                                              setTimeLimit, timeLimit,
                                              defaultWidth=160,
                                              dropdownStyle={},
                                              upIcon=null,
                                              downIcon=null,
}) {
    const { t } = useTranslation();
    let uniqueId = useId();
    const [isSelectedCustom, setIsSelectedCustom] = useState(false);
    const inputRef = useRef();
    const [inputVal, setInputVal] = useState("");

    const options = [
        {label: t('gradebook.unlimitedText'), value: "0"},
        {label: "15 " + t('questionBuilder.secondsLabel'), value: "15"},
        {label: "30 " + t('questionBuilder.secondsLabel'), value: "30"},
        {label: "1 " + t('questionBuilder.minuteLabel'), value: "60"},
        {label: t('questionBuilder.customText'), value: "-1"},
    ];

    const getSecondsFromFormatedTime = (formatedTime) => {
        if (!formatedTime) {
            return 0;
        }

        let regResult = formatedTime.match(/^([0-5]?[0-9])(:([0-5]?[0-9])?)?$/);
        if (regResult === null) {
            notifyError(t("common.invalidTime"));
            return null;
        }

        const minutes = !!regResult[1] ? parseInt(regResult[1]) : 0;
        const seconds = !!regResult[3] ? parseInt(regResult[3]) : 0;

        return minutes * 60 + seconds;
    }



    const getFormatedTimeFromSeconds = (timeLimit) => {

        let minutes = Math.floor(timeLimit / 60);
        let seconds = timeLimit % 60;

        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }


    const translateDropdownValue = (timeLimit) => {
        if (!timeLimit || isNaN(timeLimit)) {
            return "0";
        }

        if (timeLimit === 15 || timeLimit === 30 || timeLimit === 60) {
            return timeLimit.toString();
        }

        return "-1";
    }


    useEffect(() => {
        if (isSelectedCustom) {
            let input = document.getElementById(`input-${uniqueId}`);
            if (!!input) {
                input.focus();
            }
            // inputRef.current.focus();
        }
    }, [isSelectedCustom]);

    const onChangeCustomInput = (e) => {
        let input = e.target.value;

        let result = '';
        for (let i = 0; i < input.length; i++) {
            if (result.length === 2) {
                result += ':';
            }

            const char = input[i];
            if (/\d/.test(char)) {
                result += char;
            }

            if (result.length === 5) {
                break;
            }
        }

        if (result.length === 2 && inputVal.length === 1) {
            result += ':';
        }

        if (result.length >= 2) {
            result = `${Math.min(parseInt(result.slice(0, 2)), 59).toString().padStart(2, '0')}${result.slice(2, 5)}`;
        }

        if (result.length === 5) {
            result = `${result.slice(0, 2)}:${Math.min(parseInt(result.slice(3, 5)), 59).toString().padStart(2, '0')}`;
        }


        setInputVal(result);

    }

    const onBlur = (e) => {
        if (e.target.value !== undefined && e.target.value !== "") {
            let seconds = getSecondsFromFormatedTime(e.target.value);
            if (!isNaN(seconds) && !isNaN(parseInt(seconds))) {
                setTimeLimit(seconds);
            }
        } else {
            setTimeLimit(0);
        }
        setIsSelectedCustom(false);
    }

    const customPresenter = () => {
        let val = translateDropdownValue(timeLimit);
        if (val !== "0") {
            return getFormatedTimeFromSeconds(timeLimit);
        } else {
            return options.find(opt => opt.value === val).label;
        }
    }

    return (
        <div style={{position: 'relative', width: defaultWidth, }}>
            <div
                className={classes.inputContainer}
                style={{visibility: isSelectedCustom ? "visible" : "hidden", ...dropdownStyle}}
            >
                <span className={classes.icon}><TIME_LIMIT_ICON style={{width: 18, height: 18}}/></span>
                <YuJaTooltip placement={"bottom"} text={t("common.enterTime")}>
                    <input
                        id={`input-${uniqueId}`}
                        ref={inputRef}
                        value={inputVal}
                        onChange={onChangeCustomInput}
                        onBlur={onBlur}
                        placeholder={"MM:SS"}
                    />
                </YuJaTooltip>
                {isSelectedCustom &&
                    <CHECK_ICON style={{cursor: "pointer"}} title={"confirm"}/>
                }
            </div>

            <YuJaSelect
                ariaLabel={t("poll.customizeTimeLimitLabel")}
                style={{...dropdownStyle, width: defaultWidth, padding: "0 10px"}}
                downIcon={downIcon}
                options={options}
                value={translateDropdownValue(timeLimit)}
                onChange={val => {
                    if (val === "-1") {
                        setIsSelectedCustom(true);
                        setInputVal(translateDropdownValue(timeLimit) !== "-1" ? "" : getFormatedTimeFromSeconds(timeLimit));
                    } else {
                        setTimeLimit(parseInt(val));
                    }
                }}
                presenterIcon={<span className={classes.icon}><TIME_LIMIT_ICON style={{width: 18, height: 18}}/></span>}
                customPresenter={customPresenter}
            />
        </div>
    );
}